import { render, staticRenderFns } from "./TextCarousel.vue?vue&type=template&id=6132a354&scoped=true&"
import script from "./TextCarousel.vue?vue&type=script&lang=js&"
export * from "./TextCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TextCarousel.vue?vue&type=style&index=0&id=6132a354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6132a354",
  null
  
)

export default component.exports